import { useState, useEffect } from "react";

function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /* /iPad/i, */
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  let size;
  if (width < height) {
    if (width >= 768) {
      size = "sm_vertical";
    } else if (width < 768) {
      size = "xs_vertical";
    }
  } else {
    /* Horizontal screens */
    if (width < 768 && detectMob()) {
      size = "xs_vertical";
    } else if (width >= 2560 && size !== "ultrawide") {
      size = "ultrawide";
    } else if (width < 2560 && width >= 1920) {
      size = "full_horizontal";
    } else if (width < 1920 && width >= 1280) {
      size = "lg_horizontal";
    } else if (width < 1280) {
      size = "md_horizontal";
    }
  }

  return {
    width,
    height,
    size,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
